import LocationSplitRoute from '@/features/data/locations/components/LocationSplitRoute.tsx';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/data/locations/')({
  component: LocationSplitRoute,
});
